import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PwaInstallService {
    private deferredPrompt = new BehaviorSubject<any>(null);
    public promptAvailable$ = this.deferredPrompt.asObservable();

    constructor() {
        window.addEventListener('beforeinstallprompt', (e: any) => {
            e.preventDefault();
            this.deferredPrompt.next(e);
        });

        window.addEventListener('appinstalled', () => {
            this.deferredPrompt.next(null);
        });
    }

    public async showPrompt() {
        const prompt = this.deferredPrompt.value;
        if (prompt && prompt.prompt) {
            prompt.prompt();
            const { outcome } = await prompt.userChoice;
            console.log('Install outcome:', outcome);
            this.deferredPrompt.next(null);
        } else {
            console.warn('Install prompt not available');
        }
    }

    public isPromptAvailable(): boolean {
        return !!this.deferredPrompt.value;
    }
}
